module.exports = __webpack_public_path__ + "static/media/grocery-zone-wv-banner.e2b3676a.png";